import React, { Component } from "react";
import { Link } from "react-router-dom";
//simplebar
import SimpleBar from "simplebar-react";
import AddContactModal from "./AddContactModal";

export default class ChatsList extends Component {
  render() {
    return (

      <>
        {/* {this.props.isContact && (
          <div className="px-3 mb-3">
            <button className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2 py-2 shadow-sm">
              <i className="ri-user-add-line fs-5"></i>
              <span className="fw-semibold">Add New Contact</span>
            </button>
          </div>
        )} */}

        {this.props.isContact && (
          <AddContactModal addContact={this.props.addContact} />
        )}


        <div className="chats-list-h">
          {this.props.recentChatList.filter(chat => {
            if (this.props.isContact) {
              return chat.star === true && !chat?.isGroupChat;
            } else if (this.props.isGroup) {
              return chat.star === true && chat.isGroupChat;
            } else {
              return chat.star === true;
            }
          }).length > 0 && (

              <div className="px-2">
                <h5 className="mb-3 px-3 font-size-16">Favorites</h5>

                <SimpleBar className="chat-message-list">
                  <ul className="list-unstyled chat-list chat-user-list" id="chat-list">
                    {this.props.recentChatList.map((chat, key) => {
                      // Skip if not starred
                      if (!chat?.star) return null;

                      // Conditional rendering logic
                      if (
                        (this.props.isContact && chat.isGroupChat) ||
                        (this.props.isGroup && !chat.isGroupChat)
                      ) {
                        return null;
                      }

                      return (
                        <li
                          key={key}
                          id={"conversation" + key}
                          className={
                            chat.unRead
                              ? "unread"
                              : chat.isTyping
                                ? "typing"
                                : key === this.props.active_user
                                  ? "active"
                                  : ""
                          }
                        >
                          <Link to="#" onClick={(e) => {
                            this.props.openUserChat(e, chat);
                            this.props.msgSeenUpdate();
                          }}>
                            <div className="d-flex">
                              {chat.isGroupChat ? (
                                <div
                                  className={
                                    "chat-user-img " +
                                    chat.status +
                                    " align-self-center me-3 ms-0"
                                  }
                                  style={{ width: "15%" }}
                                >
                                  <img
                                    src="https://static.vecteezy.com/system/resources/thumbnails/021/063/599/small/group-coaching-icon-vector.jpg"
                                    className="rounded-circle avatar-xs"
                                    alt="chatvia"
                                  />
                                  {chat.status && <span className="user-status"></span>}
                                </div>
                              ) : !chat.user?.imageSrc ? (
                                <div
                                  className={
                                    "chat-user-img " +
                                    chat.status +
                                    " align-self-center me-3 ms-0"
                                  }
                                  style={{ width: "15%" }}
                                >
                                  <div className="avatar-xs">
                                    <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                      {chat.user?.contactName?.first?.charAt(0)}
                                    </span>
                                  </div>
                                  {chat.status && <span className="user-status"></span>}
                                </div>
                              ) : (
                                <div
                                  className={
                                    "chat-user-img " +
                                    chat.status +
                                    " align-self-center me-3 ms-0"
                                  }
                                  style={{ width: "15%" }}
                                >
                                  <img
                                    src={chat?.user?.imageSrc}
                                    className="rounded-circle avatar-xs"
                                    alt="chatvia"
                                  />
                                  {chat.status && <span className="user-status"></span>}
                                </div>
                              )}
                              {/* {!chat.user?.imageSrc ? (
                                <div
                                  className={`chat-user-img ${chat.status} align-self-center me-3 ms-0`}
                                  style={{ width: "15%" }}
                                >
                                  <div className="avatar-xs">
                                    <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                      {chat.user?.contactName?.first?.charAt(0)}
                                    </span>
                                  </div>
                                  {chat.status && <span className="user-status"></span>}
                                </div>
                              ) : (
                                <div
                                  className={`chat-user-img ${chat.status} align-self-center me-3 ms-0`}
                                  style={{ width: "15%" }}
                                >
                                  <img
                                    src={chat.user.imageSrc}
                                    className="rounded-circle avatar-xs"
                                    alt="chatvia"
                                  />
                                  {chat.status && <span className="user-status"></span>}
                                </div>
                              )} */}

                              <div className="flex-grow-1 overflow-hidden" style={{ width: "65%" }}>
                                <h5 className="text-truncate font-size-15 mb-1">
                                  {chat.name}
                                </h5>
                                <p className="chat-user-message text-truncate mb-0">
                                  {chat.isTyping ? (
                                    <>
                                      typing
                                      <span className="animate-typing">
                                        <span className="dot ms-1"></span>
                                        <span className="dot ms-1"></span>
                                        <span className="dot ms-1"></span>
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      {this.props.conversations[key]?.[0]?.[this.props.conversations[key][0].length - 1]?.media?.length >= 1 && (
                                        <i className="ri-image-fill align-middle me-1"></i>
                                      )}
                                      {this.props.conversations[key]?.[0]?.[this.props.conversations[key][0].length - 1]?.isFileMessage && (
                                        <i className="ri-file-text-fill align-middle me-1"></i>
                                      )}
                                      {
                                        this.props.conversations[key]?.[0]?.[this.props.conversations[key][0].length - 1]?.message
                                      }
                                    </>
                                  )}
                                </p>
                              </div>

                              <div className="font-size-11" style={{ width: "20%" }}>
                                {this.props.conversations[key]?.[0]?.[this.props.conversations[key][0].length - 1]?.createdAt &&
                                  this.props.formatDate(
                                    new Date(
                                      this.props.conversations[key][0][
                                        this.props.conversations[key][0].length - 1
                                      ].createdAt
                                    )
                                  )}
                              </div>

                              {chat.unRead > 0 && (
                                <div className="unread-message" id={"unRead" + chat.id}>
                                  <span className="badge badge-soft-danger rounded-pill">
                                    {chat.unRead >= 20 ? `${chat.unRead}+` : chat.unRead}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </SimpleBar>
              </div>
            )}

          <div className="px-2">
            <h5 className="mb-3 px-3 font-size-16">Recent</h5>
            <SimpleBar style={{ maxHeight: "100%" }} className="chat-message-list">
              <ul className="list-unstyled chat-list chat-user-list" id="chat-list">
                {this.props.recentChatList.map((chat, key) => {
                  // Skip starred chats
                  if (chat?.star) return null;

                  // Conditional rendering logic
                  if (
                    (this.props.isContact && chat.isGroupChat) ||
                    (this.props.isGroup && !chat.isGroupChat)
                  ) {
                    return null;
                  }

                  return (
                    <li
                      key={key}
                      id={"conversation" + key}
                      className={
                        chat.unRead
                          ? "unread"
                          : chat.isTyping
                            ? "typing"
                            : key === this.props.active_user
                              ? "active"
                              : ""
                      }
                    >
                      <Link to="#" onClick={(e) => {
                        this.props.openUserChat(e, chat)
                        this.props.msgSeenUpdate();
                      }}>
                        <div className="d-flex">
                          {chat.isGroupChat ? (
                            <div
                              className={
                                "chat-user-img " +
                                chat.status +
                                " align-self-center me-3 ms-0"
                              }
                              style={{ width: "15%" }}
                            >
                              <img
                                src="https://static.vecteezy.com/system/resources/thumbnails/021/063/599/small/group-coaching-icon-vector.jpg"
                                className="rounded-circle avatar-xs"
                                alt="chatvia"
                              />
                              {chat.status && <span className="user-status"></span>}
                            </div>
                          ) : !chat.user?.imageSrc ? (
                            <div
                              className={
                                "chat-user-img " +
                                chat.status +
                                " align-self-center me-3 ms-0"
                              }
                              style={{ width: "15%" }}
                            >
                              <div className="avatar-xs">
                                <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                  {chat.user?.contactName?.first?.charAt(0)}
                                </span>
                              </div>
                              {chat.status && <span className="user-status"></span>}
                            </div>
                          ) : (
                            <div
                              className={
                                "chat-user-img " +
                                chat.status +
                                " align-self-center me-3 ms-0"
                              }
                              style={{ width: "15%" }}
                            >
                              <img
                                src={chat?.user?.imageSrc}
                                className="rounded-circle avatar-xs"
                                alt="chatvia"
                              />
                              {chat.status && <span className="user-status"></span>}
                            </div>
                          )}

                          <div className="flex-grow-1 overflow-hidden" style={{ width: "65%" }}>
                            <h5 className="text-truncate font-size-15 mb-1">{chat.name}</h5>
                            <p className="chat-user-message text-truncate mb-0">
                              {chat.isTyping ? (
                                <>
                                  typing
                                  <span className="animate-typing">
                                    <span className="dot ms-1"></span>
                                    <span className="dot ms-1"></span>
                                    <span className="dot ms-1"></span>
                                  </span>
                                </>
                              ) : (
                                <>
                                  {this.props.conversations[key]?.length > 0 &&
                                    this.props.conversations[key][0] &&
                                    this.props.conversations[key][0].length > 0 &&
                                    this.props.conversations[key][0][
                                      this.props.conversations[key][0].length - 1
                                    ].media.length >= 1 ? (
                                    <i className="ri-image-fill align-middle me-1"></i>
                                  ) : null}
                                  {this.props.conversations[key]?.length > 0 &&
                                    this.props.conversations[key][0] &&
                                    this.props.conversations[key][0].length > 0 &&
                                    this.props.conversations[key][0][
                                      this.props.conversations[key][0].length - 1
                                    ].isFileMessage === true ? (
                                    <i className="ri-file-text-fill align-middle me-1"></i>
                                  ) : null}
                                  {this.props.conversations[key]?.length > 0 &&
                                    this.props.conversations[key][0] &&
                                    this.props.conversations[key][0].length > 0
                                    ? this.props.conversations[key][0][
                                      this.props.conversations[key][0].length - 1
                                    ].message
                                    : null}
                                </>
                              )}
                            </p>
                          </div>

                          <div className="font-size-11" style={{ width: "20%" }}>
                            {this.props.conversations[key]?.length > 0 &&
                              this.props.conversations[key][0] &&
                              this.props.conversations[key][0].length > 0
                              ? this.props.formatDate(
                                new Date(
                                  this.props.conversations[key][0][
                                    this.props.conversations[key][0].length - 1
                                  ].createdAt
                                )
                              )
                              : null}
                          </div>

                          {chat.unRead === 0 ? null : (
                            <div className="unread-message" id={"unRead" + chat.id}>
                              <span className="badge badge-soft-danger rounded-pill">
                                {chat.messages && chat.messages.length > 0
                                  ? chat.unRead >= 20
                                    ? chat.unRead + "+"
                                    : chat.unRead
                                  : ""}
                              </span>
                            </div>
                          )}
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </SimpleBar>
          </div>

        </div>
      </>
    )
  }
}
